import React, { useContext} from "react";
import "./profilLogin.css"
import { AppContext } from "../../context/AppContext";
import { Link, useLocation } from "react-router-dom";
const ProfilLogin = () => {

    const {firstName,imgProfil} = useContext(AppContext)
    const location = useLocation()
    return ( 
        <>
            <Link to={'/profilScreen'} state={{ backTo: { pathname: location.pathname, search: location.search, state: location.state}}} className='iconProfil pointer' style={{backgroundSize:"cover",...(imgProfil? {backgroundImage: `url(${imgProfil})`} : {})}} >
                {imgProfil === '' && <p className="largeTitle lowOpacityHover"  >{firstName ? firstName[0].toUpperCase() : ''}</p> }
            </Link>
        </>
    )
}

export default ProfilLogin